
import {  USERS_API } from "@/utils/apiUrl"
import backend from "@/utils/backend"
import * as types from "./mutation_types"
import notif from "@/utils/notify"

export const del = ({ commit }, id) => {
  
   
    const url = `${id}/${USERS_API}/${id}`
    commit(types.SET_SHOW_LOADING)
    let user = "Oups, l'opération a échouée"
    let toastType = "error";
    backend({ url, data: null, method: "DELETE" }).then(({ data }) => {
        commit(types.SET_ITEMS, data)
        commit(types.SET_IS_SUCCESS)
        user ="Super,l'opération a été effectuée";
        toastType = "success";
        commit(types.SET_USER, "Super,l'opération a été effectuée")
        commit(types.SET_CURRENT_ITEM, null)
    }).catch((err) => {
        commit(types.SET_IS_ERROR)
        commit(types.SET_SHOW_USER)
        commit(types.SET_USER, (err?.response?.user ?? err.user ?? err))
    }).finally(() => {
        commit(types.SET_SHOW_USER)
        commit(types.SET_HIDE_LOADING)
        commit(types.RESET)

        notif(user,toastType)

    })
}


export const resetData = ({ commit }) => {

    commit(types.RESET)
}



